import React from "react";
import styled from "styled-components";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: 400;
    font-size: 13px;
    color: ${(props) => (props.color ? props.color : "#6B7280")};
    margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "16px")};

    svg {
        width: 10px;
        height: 10px;
    }
`;

function Info({ children, marginBottom, color }) {
    return (
        <Container
            marginBottom={marginBottom}
            color={color}
        >
            <ErrorOutlineIcon />
            {children}
        </Container>
    );
}

export default Info;
